import * as React from "react";
import { useGetAllCompaniesQuery } from "../services/company.service";
import SelectBase, { SelectOption } from "./global/SelectBase";

const SelectCompany = ({
  onChange,
  sx,
  value,
  error,
  helperText,
}: {
  onChange: (arg?: number) => void;
  sx?: any;
  value: number;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const {
    data: companies,
    isLoading,
  } = useGetAllCompaniesQuery({
    sortField: "name",
    sortMode: "asc",
  });

  const options = React.useMemo<SelectOption[]>(() => {
    return (companies || []).map((company) => ({
      label: company.name,
      value: company.id,
    }));
  }, [companies]);

  const selected = React.useMemo<SelectOption | null>(() => {
    if (!value || !companies) return null;
    const company = companies.find((it) => it.id === value);
    return company ? { label: company.name, value: company.id } : null;
  }, [companies, value]);

  return (
    <SelectBase
      options={options}
      value={selected}
      onChange={(newValue) => {
        const option = newValue as SelectOption | null;
        onChange(option?.value as number | undefined);
      }}
      label="Company"
      placeholder="Search..."
      isLoading={isLoading}
      error={error}
      helperText={helperText}
      sx={sx}
    />
  );
};
export default SelectCompany;
